import domReady from "@wordpress/dom-ready";
import "swiper/css";
import { swiperCreateNew } from "./swiper-settings";

domReady(() => {
	const allCarouselSections = document.querySelectorAll(
		".wp-block-zebra-blocks-carousel"
	);
	allCarouselSections.forEach((section) => {
		const thisSwiper = swiperCreateNew(section.id);
	});
});
